/**
 * MessageTemplateContainer
 * --
 */
import React from 'react';
import MessageTemplatePresenter from './MessageTemplatePresenter';

const MessageTemplateContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <MessageTemplatePresenter />
    </>
  );
};

export default MessageTemplateContainer;
